import { mockOpenDayData } from './mock-open-day-data';

/**
 * Read data from embedded JSON script tag
 */
const getEmbeddedData = () => {
  const scriptTag = document.getElementById('open-day-data');
  if (scriptTag) {
    try {
      return JSON.parse(scriptTag.textContent);
    } catch (e) {
      console.error('Failed to parse open-day-data:', e);
      return null;
    }
  }
  return null;
};

const toArray = (value) => (Array.isArray(value) ? value : []);
const isDev = process.env.NODE_ENV === 'development';

export async function getProgrammes(lang) {
  // Get open days from embedded data (Cardiff feed) or MockData if true
  const data = getEmbeddedData();
  const useMock = isDev && data?.useMockData === true;
  if (useMock) return toArray(mockOpenDayData.openDays);
  if (data?.openDays) return toArray(data.openDays);
  if (isDev) return toArray(mockOpenDayData.openDays);
  return [];
}

export async function getProgrammesByOpenDay(openDayId, lang) {
  const data = getEmbeddedData();
  const useMock = isDev && data?.useMockData === true;
  const isPreprod = data?.feedEnvironment === 'preprod';
  if (useMock) {
    return toArray(mockOpenDayData.topicsByOpenDay?.[String(openDayId)]);
  }
  const embeddedTopics =
    data?.topicsByOpenDay?.[String(openDayId)] ||
    data?.topicsByOpenDay?.[openDayId];

  if (embeddedTopics) return toArray(embeddedTopics);

  const langPath = lang === 'cy' ? 'cy' : 'en';

  const url = isPreprod
    ? (langPath === 'cy'
        ? `/cy/feeds/json/open-day-feed-preprod?id=${openDayId}`
        : `/feeds/json/open-day-feed-preprod?id=${openDayId}`)
    : (langPath === 'cy'
        ? `/cy/feeds/json/open-day-feed?id=${openDayId}`
        : `/feeds/json/open-day-feed?id=${openDayId}`);

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();

    // Return the topics array (or transform if needed)
    if (data && Array.isArray(data.topics)) {
      return data.topics;
    }

    // If it's an array of topics, return it
    if (Array.isArray(data)) {
      return data;
    }

    return isDev ? toArray(mockOpenDayData.topicsByOpenDay?.[String(openDayId)]) : [];
  } catch (error) {
    console.error('Failed to fetch programmes:', error);
    return isDev ? toArray(mockOpenDayData.topicsByOpenDay?.[String(openDayId)]) : [];
  }
}
